/* Import Estilo */
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/* Import Bibliotecas */
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/* Import Componentes */
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';

/* Import Requisição API */
import api from '../../../../api';
import MapComponent from '../../../../components/MapComponet';
import { formatadorNumeroCelular, formatarCpfCnpj } from '../../../../utils/Validadores';

export default function VisualizarFuncionario() {
    /* Variáveis auxiliares para dados */
    const location = useLocation();
    const navigate = useNavigate();
    const id = location.state?.id;

    /* ID's */
    const [idFuncionario, setIdFuncionario] = useState("");
    const [usuario_id, setIdUsuario] = useState();
    const [idFuncionarioParaExcluir, setIdFuncionarioParaExcluir] = useState(null);

    /* Variáveis de Dados do Funcionário */
    const [nome, setNome] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");
    const [sexo, setSexo] = useState("");
    const [nivelAcesso, setNivelAcesso] = useState("");
    const [termosAceitos, setTermosAceitos] = useState("");
    const [aceitoEnvioEmail, setAceitoEnvioEmail] = useState("");

    /* Variáveis de Dados de Endereço do Funcionário */
    const [cep, setCep] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [destination, setDestination] = useState(null);

    /* Variáveis de Logs do Funcionário */
    const [logs, setLogs] = useState([]);
    const [filtroData, setFiltroData] = useState('');
    const [filtroAcao, setFiltroAcao] = useState('');
    const [filtroDataOrdenacao, setFiltroDataOrdenacao] = useState('');

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    /* Dialog de exclusão de funcionário */
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    useEffect(() => {
        if (id) setIdFuncionario(id);
    }, [id]);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const abrirModalExcluir = (id_funcionario) => {
        setIdFuncionarioParaExcluir(id_funcionario);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        setModalAberto(false);
        caixaDeDialogo.current?.close();
        setIdFuncionarioParaExcluir(null);
    };

    const confirmarExcluirFuncionario = async () => {
        try {
            await api.delete(`/funcionarios/${idFuncionarioParaExcluir}`, {
                data: { usuario_id }
            });
            fecharModal();
            navigate('/menu/funcionarios');
        } catch (error) {
            fecharModal();
            setTexto(error.response?.data?.message || 'Erro ao excluir funcionário.')
            abrirModalAviso();
        }
    };

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    /* Função que redireciona para editar funcionário */
    const handleEdit = (id) => navigate("/menu/funcionarios/editarfuncionario", { state: { id } });

    /* Busca os dados do Funcionário */
    useEffect(() => {
        setLoading(true);
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                console.log("Resposta da API:", response.data);
                if (response.data.success) {
                    console.log('Passei aqui');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
        const carregarDados = async () => {
            try {
                const response = await api.get(`/funcionarios/${idFuncionario}`);
                if (response.data.success) {
                    const funcionario = response.data.funcionario;

                    setIdUsuario(funcionario.usuario_id);
                    setNome(funcionario.nome || '');
                    setCpfCnpj(formatarCpfCnpj(funcionario.cpf_cnpj) || '');
                    setEmail(funcionario.email || '');
                    setCelular(formatadorNumeroCelular(funcionario.celular) || '');
                    setDataNascimento(
                        funcionario.data_nascimento
                            ? new Date(funcionario.data_nascimento).toLocaleDateString("pt-BR")
                            : ""
                    );
                    setSexo(funcionario.sexo || '');
                    setNivelAcesso(funcionario.nivelAcesso || 'Funcionário');
                    setTermosAceitos(funcionario.termosAceitos || false);
                    setAceitoEnvioEmail(funcionario.aceitoEnvioEmail || false);

                    if (funcionario.endereco) {
                        const {
                            cep,
                            logradouro,
                            numero,
                            complemento,
                            bairro,
                            cidade,
                            estado,
                        } = funcionario.endereco;

                        setCep(cep || '');
                        setLogradouro(logradouro || '');
                        setNumero(numero || '');
                        setComplemento(complemento || '');
                        setBairro(bairro || '');
                        setCidade(cidade || '');
                        setEstado(estado || '');

                        if (!logradouro || !numero || !bairro || !cidade || !estado) {
                            console.warn("Endereço incompleto para geocodificação.");
                            return;
                        }

                        const enderecoCompleto = `${logradouro}, ${numero}, ${bairro}, ${cidade}, ${estado}, Brasil`;
                        const geocodeUrl = `/geocode?endereco=${encodeURIComponent(enderecoCompleto)}`;

                        const res = await api.get(geocodeUrl);

                        if (res.data && res.data.length > 0) {
                            const lat = parseFloat(res.data[0].lat);
                            const lon = parseFloat(res.data[0].lon);
                            setDestination({ lat, lng: lon });
                        } else {
                            console.warn("Endereço não encontrado na geocodificação.");
                        }

                        const logsResponse = await api.get('/logs', {
                            params: {
                                usuario_id: idFuncionario,
                                ordem: filtroDataOrdenacao
                            }
                        });

                        if (logsResponse.data.success) {
                            setLogs(logsResponse.data.data);
                        } else {
                            console.warn("Nenhum log encontrado.");
                        }
                    }
                } else {
                    setTexto('Erro ao carregar os dados do funcionário.');
                }
                setLoading(false);
            } catch (error) {
                console.error("Erro ao carregar dados do funcionário ou geocodificar:", error);
            } finally {
                setLoading(false);
            }
        };

        if (idFuncionario) carregarDados();
    }, [idFuncionario, filtroAcao, filtroDataOrdenacao]);

    const logsFiltrados = logs.filter((log) => {
        const data = new Date(log.data).toLocaleDateString('pt-BR');
        const acao = log.acao.toLowerCase();
        return (
            (filtroData === '' || data.includes(filtroData)) &&
            (filtroAcao === '' || acao.includes(filtroAcao.toLowerCase()))
        );
    });

    return (
        <section className="container-principal-visualizarFuncionario">

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse funcionário?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirFuncionario}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main className="main-visualizarFuncionario">
                <MenuLateral />
                <section className="conteudo-visualizarFuncionario">
                    <div className="titulo-visualizarFuncionario">
                        <h1><span>Funcionários</span> &gt; Visualizar Funcionário</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando dados do funcionário</h2>
                        </div>
                    ) : (
                    <div className="detalhes-funcionario">
                        <div className="conteudo-DescricaoFuncionario">
                            <div className="cabecalho-DescricaoFuncionarioTitulo">
                                <h2>Dados do Funcionário</h2>
                            </div>

                            <div className="dados-DescricaoFuncionario">
                                <div className="dadoDuplo">
                                    <div className="dado"><strong>Nome:</strong><p>{nome}</p></div>
                                    <div className="dado"><strong>CPF/CNPJ:</strong><p>{cpfCnpj}</p></div>
                                </div>

                                <div className="dadoDuplo">
                                    <div className="dado"><strong>Email:</strong><p>{email}</p></div>
                                    <div className="dado"><strong>Celular:</strong><p>{celular}</p></div>
                                </div>

                                <div className="dadoDuplo">
                                    <div className="dado"><strong>Data de nascimento:</strong><p>{dataNascimento}</p></div>
                                    <div className="dado"><strong>Sexo:</strong><p>{sexo}</p></div>
                                    <div className="dado"><strong>Perfil:</strong><p>{nivelAcesso}</p></div>
                                </div>

                                <div className="bnt-acoes">
                                    <a href={`https://wa.me/55${celular.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer" className="botao-whatsapp"><svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.907305 38.4919L10.6554 35.9295C13.3885 37.4 16.4537 38.1814 19.575 38.1814C29.9506 38.1814 38.4063 29.7257 38.4063 19.3501C38.4063 14.3154 36.4489 9.58321 32.896 6.03C31.1535 4.27058 29.0782 2.87553 26.7912 1.92613C24.5041 0.976711 22.0509 0.491952 19.5746 0.500101C9.1992 0.500327 0.74375 8.95592 0.74375 19.3314C0.74375 22.6216 1.59953 25.8188 3.20039 28.6466L0.602537 38.1844L0.488825 38.6019L0.907305 38.4919ZM11.074 32.0458L5.64271 33.4733L7.08492 28.1909L7.11431 28.0833L7.05382 27.9896L6.68061 27.4111C6.68032 27.4107 6.68002 27.4102 6.67972 27.4097C5.16309 24.988 4.35796 22.1886 4.35625 19.3312C4.35633 10.9568 11.1819 4.13135 19.5562 4.13135C23.6148 4.13135 27.4322 5.71737 30.2914 8.59506L30.2924 8.59606C31.7082 10.005 32.8302 11.681 33.5933 13.5268C34.3563 15.3727 34.7452 17.3518 34.7375 19.3491L34.7375 19.3512C34.7744 27.7242 27.95 34.5313 19.575 34.5313C16.8453 34.5313 14.1707 33.7937 11.8278 32.4102C11.8276 32.4101 11.8273 32.41 11.8271 32.4098L11.2661 32.0732L11.1758 32.019L11.074 32.0458ZM24.9759 21.4812L24.976 21.4809L24.9634 21.4765C24.7563 21.4044 24.5203 21.3256 24.2865 21.3516C24.0258 21.3806 23.8138 21.5297 23.6272 21.7931L23.6272 21.7931L23.6245 21.797C23.3154 22.2516 22.4437 23.2911 22.1806 23.5917L22.1805 23.5917L22.1758 23.5974C22.0698 23.7261 21.9875 23.7663 21.9111 23.7752C21.8228 23.7854 21.6893 23.7603 21.4716 23.647L21.4716 23.6469L21.4644 23.6435C21.3926 23.609 21.2997 23.569 21.1877 23.5208C20.5419 23.2427 19.2653 22.6931 17.7916 21.3762L17.7914 21.376C16.4373 20.1683 15.5357 18.6819 15.2539 18.2123C15.1512 18.0276 15.1622 17.926 15.186 17.8597C15.2181 17.7704 15.2928 17.6858 15.4205 17.5581C15.5694 17.4093 15.75 17.191 15.9171 16.9891C15.9912 16.8996 16.0625 16.8134 16.1273 16.7378C16.354 16.4733 16.4627 16.2545 16.5919 15.9945C16.6043 15.9694 16.6169 15.944 16.6299 15.9182L16.6299 15.9182L16.6325 15.9128C16.8283 15.4966 16.7223 15.1481 16.5924 14.8883C16.4859 14.6753 15.5537 12.4018 15.1759 11.4573L15.1759 11.4572L15.1745 11.4539C14.9754 10.9759 14.7503 10.7154 14.4919 10.5912C14.2953 10.4967 14.0831 10.4959 13.9689 10.4955C13.9446 10.4954 13.9247 10.4954 13.9104 10.4944L13.9021 10.4939H13.8938H12.9937C12.6168 10.4939 12.0583 10.6276 11.5723 11.1558L11.5722 11.1558L11.5686 11.1599C11.5373 11.1955 11.501 11.2353 11.4607 11.2795C10.9727 11.8146 9.89375 12.9977 9.89375 15.2064C9.89375 16.4064 10.33 17.5724 10.7834 18.4649C11.2339 19.3517 11.7123 19.9895 11.8338 20.1514L11.8352 20.1533C11.8448 20.167 11.8592 20.1881 11.8783 20.216C12.3252 20.8701 15.3513 25.2985 19.8688 27.248C20.9859 27.7402 21.8577 28.0246 22.5376 28.2324C23.6943 28.6045 24.749 28.5438 25.5721 28.429L25.5736 28.4287C26.0709 28.3562 26.794 28.0562 27.4352 27.644C28.0696 27.2362 28.6879 26.6778 28.9045 26.0521C29.1083 25.4887 29.2114 24.9663 29.246 24.553C29.2633 24.3465 29.2639 24.1631 29.2499 24.013C29.237 23.8749 29.209 23.7272 29.1422 23.6221C29.0413 23.4636 28.8914 23.3636 28.7346 23.2802C28.6417 23.2307 28.5264 23.1775 28.4003 23.1193C28.3228 23.0835 28.2412 23.0458 28.1582 23.006C28.0479 22.9531 27.8306 22.8471 27.5582 22.7144C26.7 22.2963 25.2959 21.6121 24.9759 21.4812ZM25.5375 28.1815L25.5375 28.1815L25.5375 28.1815Z" stroke-width="0.5" /></svg>Conversar no WhatsApp</a>
                                    <a href={`mailto:${email}`} className="botao-email"><svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.5795 17.5022L34.35 8.27064V26.6H4.65V8.27064L19.4205 17.5022L19.5 17.5519L19.5795 17.5022ZM38.4 4.25C38.4 2.10466 36.6453 0.35 34.5 0.35H4.5C2.35466 0.35 0.6 2.10466 0.6 4.25V26.75C0.6 28.8953 2.35466 30.65 4.5 30.65H34.5C36.6453 30.65 38.4 28.8953 38.4 26.75V4.25ZM19.5 13.4481L5.02302 4.4H33.977L19.5 13.4481Z" stroke-width="0.3" /></svg>Enviar E-mail</a>
                                </div>
                            </div>
                        </div>

                        <div className="endereco-funcionario">
                            <div className="cabecalho-endereco">
                                <h2>Endereço do Funcionário</h2>
                            </div>
                            <div className="container-interno-endereco">
                                <div className="dados-endereco">
                                    <div className="dadoDuplo">
                                        <div className="dado">
                                            <strong className="titulo">CEP:</strong>
                                            <p> {cep}</p>
                                        </div>
                                        <div className="dado">
                                            <strong className="titulo">Número:</strong>
                                            <p> {numero}</p>
                                        </div>
                                    </div>

                                    <strong>Logradouro:</strong>
                                    <p> {logradouro}</p>

                                    <strong>Bairro:</strong>
                                    <p> {bairro}</p>

                                    <div className="dadoDuplo">
                                        <div className="dado">
                                            <strong className="titulo">Cidade:</strong>
                                            <p> {cidade}</p>
                                        </div>
                                        <div className="dado">
                                            <strong className="titulo">Estado:</strong>
                                            <p> {estado}</p>
                                        </div>
                                    </div>
                                    <strong>Complemento:</strong>
                                    <p>{complemento}</p>
                                </div>
                                <div className="mapa">
                                    <MapComponent
                                        destination={destination}
                                        showUserLocation={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="logs-funcionario">
                            <div className="cabecalho-logs">
                                <h2>Log do Funcionário</h2>
                            </div>
                            <div className="container-interno-logs">
                                <div className="filtros-logs">
                                    <div className='barraDePesquisa-e-log-container'>
                                        <div className='barraDePesquisa-log'>
                                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z" stroke="#131C46" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                            <input
                                                type="text"
                                                placeholder="Pesquise o Log do Funcionario pela: Ação"
                                                value={filtroAcao}
                                                onChange={(e) => setFiltroAcao(e.target.value)}
                                            />
                                        </div>
                                        <div className='log-select'>

                                            <select
                                                value={filtroDataOrdenacao}
                                                onChange={(e) => setFiltroDataOrdenacao(e.target.value)}
                                            >
                                                <option value="mais-recente">Mais Recente</option>
                                                <option value="mais-antigo">Mais Antigo</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="lista-logs">
                                    {logsFiltrados.length > 0 ? (
                                        <ul className='conteudo-log'>
                                            {logsFiltrados.map((log, index) => (
                                                <li key={index} className="item-log">
                                                    <p>
                                                        <strong>
                                                            {new Date(log.data).toLocaleString("pt-BR", {
                                                                dateStyle: "short",
                                                                timeStyle: "short",
                                                                timeZone: "America/Sao_Paulo"
                                                            })}
                                                        </strong>: {log.acao} — {log.detalhes}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className='texto-naoEncontrado' aria-live="polite">Nenhuma atividade encontrada.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="bnts-funcionario">
                            <button
                                className="bnt-editar"
                                onClick={() => handleEdit(idFuncionario)}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    {" "}
                                    <path
                                        d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z"
                                        stroke-width="2.08333"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                Editar Funcionário
                            </button>
                            <button
                                className="bnt-excluir"
                                onClick={() => abrirModalExcluir(idFuncionario)}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    {" "}
                                    <path
                                        d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333"
                                        stroke-width="2.08333"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                                Excluir Funcionário
                            </button>
                        </div>
                    </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}